import { Mesh } from 'three';
// import { GLTFLoadPromise } from '../../../../vendors/ngab/threejs/load/GLTFLoadPromise';
import { FBXLoadPromise } from '../../../../vendors/ngab/threejs/load/FBXLoadPromise';
import { UNIT } from '../../../constants/sizes';
import { RoundedRect } from '../geometries/RoundedRect';

//
// Prepared geometries storage:
// (e.g. preloaded)

const geometriesMap = new Map();

export const GeometriesFactory = {
    async create(type, data, name) {
        // Add switch instructions to add options

        let geom = null;
        let error;
        const {
            src
        } = data;

        /* switch (type) {

            case 'gltf':
                loaded = await GLTFLoadPromise(src);

                if (loaded.scene) {
                    geom = loaded.scene;

                    if (geom.children.length === 1) [geom] = geom.children;
                } else {
                    error = loaded;
                }

                break;

            case 'fbx': */
        const loaded = await FBXLoadPromise(src);

        if (loaded.children) {
            const meshes = loaded.children.filter((obj) => (obj instanceof Mesh));

            if (meshes.length === 1 && meshes[0].children.length < 1) {
                geom = meshes[0].geometry;
            } else geom = meshes;
        } else {
            error = loaded;
        }

        /* break;

            default:
                geom = null;

                break;
        } */

        if (geom instanceof Mesh) {
            geom = geom.geometry;
        }

        if (error instanceof Error) {
            console.warn(`Failed to get the geometry ${data}: ${geom}`);
        } else if (typeof name === 'string') {
            geometriesMap.set(name, geom);
        }

        return geom;
    },

    async preload(collection, progressUpdate) {
        if (!(collection instanceof Array)) return [];

        let geometriesLoaded;

        try {
            const { length } = collection;
            let loaded = 0;

            progressUpdate(0.01);
            geometriesLoaded = await Promise.all(collection.map(async (item) => {
                const geom = await GeometriesFactory.create(item.type, item, item.name);

                loaded += 1;
                progressUpdate(0.01 + 0.99 * (loaded / length));

                return geom;
            }));
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('Geometry loading failed', e);
        }

        if (!geometriesLoaded) return [];

        const names = Object.keys(geometriesLoaded);

        names.forEach((name) => {
            const item = geometriesLoaded[name];

            geometriesMap.set(name, item.geometry);

        });

        return geometriesLoaded;
    },

    construct(name) {
        if (name === 'banknoteRect') {
            // MAKE ROUNDED
            const roundedRect = new RoundedRect(UNIT.refSize * 0.3 * 0.7, UNIT.refSize * 0.15 * 0.7, UNIT.refSize * 0.01 * 0.7, UNIT.refSize);

            roundedRect.translate(0, 0, -UNIT.refSize);

            return roundedRect;
        }

        return null;
    },

    get(name) {
        return geometriesMap.get(name);
    },

    remove(name) {
        geometriesMap.delete(name);
    },

    clear() {
        geometriesMap.clear();
    }
};
